module.exports = __webpack_public_path__ + "static/media/news-pro-assistant.d985c576.png";